import React from 'react';
import { connect } from 'react-redux';

import { ConnectedProps } from 'mf-shared/types/common';
import { sendVerifyEmail } from '../../state/verifyEmail/actions';

import styles from './VerifyEmail.css';

function mapStateToProps(state) {
  return {
    data: {
      verifyEmail: state.verifyEmail,
    },
  };
}

const connector = connect(mapStateToProps);

interface VerifyEmailProps {
  readonly params: any;
}

type Props = ConnectedProps<typeof connector, VerifyEmailProps>;

class VerifyEmail extends React.Component<Props> {
  componentDidMount() {
    const { params, dispatch } = this.props;
    const accessToken = params.token;

    dispatch(sendVerifyEmail(accessToken));
  }

  render() {
    const { data } = this.props;
    const { invalidTokenVerifyEmail } = data.verifyEmail;

    return (
      <div className="container">
        <div className="row">
          {invalidTokenVerifyEmail && (
            <div className={styles['invalid-message']}>
              There is a problem during the registration process. Please kindly
              register again.
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default connector(VerifyEmail);
